'use strict';

var WS = global.MozWebSocket || global.WebSocket;

module.exports = {
  create: function(url, protocols, options) {
    return new WS(url);
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/util/websocket/browser_websocket.js
 ** module id = 27
 ** module chunks = 0
 **/